import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Szczegóły oferty',
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Ustaw kwalifikującą kwotę i rabat %',
      qualifying_criteria: {
        title: 'Minimalna kwota zamówienia',
        description: 'Ustaw kwalifikującą kwotę zamówienia',
      },
      details: {
        title: 'Rabat %',
        description: 'Ustaw rabat, który klienci otrzymają od zamówienia',
      },
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      title: 'Ustaw kwalifikujące produkty i rabat %',
      qualifying_criteria: {
        title: 'Produkty z rabatem',
        description: 'Wybierz produkty, na które oferujesz rabat.',
      },
      details: {
        title: 'Rabat %',
        description: 'Ustaw rabat, który klienci otrzymają od zamówienia',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      title: 'Ustaw kwalifikujące produkty i rabat {{currency}}',
      qualifying_criteria: {
        title: 'Produkty z rabatem',
        description: 'Wybierz produkty, na które oferujesz rabat.',
      },
      details: {
        title: 'Rabat {{currency}}',
        description: 'Ustaw rabat, który klienci otrzymają od zamówienia',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Ustaw kwalifikującą kwotę i rabat {{currency}}',
      qualifying_criteria: {
        title: 'Minimalna kwota zamówienia',
        description: 'Ustaw kwalifikującą kwotę zamówienia',
      },
      details: {
        title: 'Rabat {{currency}}',
        description: 'Ustaw rabat, który klienci otrzymają od zamówienia',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      title: 'Ustaw kwalifikującą kwotę i darmowe produkty',
      qualifying_criteria: {
        title: 'Minimalna kwota zamówienia',
        description: 'Ustaw kwotę, którą klient musi wydać, aby otrzymać darmowy produkt.',
      },
      details: {
        title: 'Darmowe produkty:',
        description: 'Wybierz darmowy produkt (lub produkty), z których klient może wybrać jeden.',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      title: 'Wybierz wymagania oferty',
      qualifying_criteria: {
        title: 'Kwalifikujące produkty',
        description: 'Wybierz produkty, które klient musi zamówić, aby otrzymać darmowy produkt.',
      },
      details: {
        title: 'Darmowe produkty:',
        description: 'Wybierz darmowy produkt (lub produkty), z których klient może wybrać jeden.',
      },
    },
    [OFFER_KIND.BOGO]: {
      title: 'Wybierz wymagania oferty',
      qualifying_criteria: {
        title: 'Kwalifikujące produkty',
        description: 'Wybierz kategorię, z której klient musi wybrać, aby otrzymać darmowy produkt.',
      },
      details: {
        title: 'Darmowy produkt',
        description:
          'Klienci mogą wybrać drugi produkt spośród kwalifikujących pozycji. Klient otrzyma tańszy z dwóch produktów gratis.',
      },
    },
  },
};
